import script from "./withdrawPasswordPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./withdrawPasswordPopup.vue?vue&type=script&setup=true&lang=ts"

import "./withdrawPasswordPopup.vue?vue&type=style&index=0&id=658984f5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-658984f5"]])

export default __exports__